import {css} from 'lit-element'; export default css`.no-widgets-message{margin:2rem;text-align:center}`;
    